import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import {  Row, Col, Container } from "react-bootstrap";
import { generatePdf, exportToExcel, datetime, commonSelectProps } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";import Select from 'react-select';
export default function DeptwiseMappedOfficers() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); const [logindeptid, setlogindeptid] = useState(""); const [Deptlist, setDeptlist] = useState([]); const [MandalList, setMandalList] = useState([]); const [distlist, setDistrictList] = useState([]); const [dists, setDists] = useState([]); const [ulblist, setulblist] = useState(); const [Empdata, setEmpdata] = useState([]); const [distEnb, setDistEnb] = useState(false); const [mandalenb, setmandalenb] = useState(false); const [searchText1, setSearch1] = useState(""); const [deptnb, setDeptEnb] = useState(false); const[currentdate,setcurrentdate] =useState(''); const[currenttime,setcurrenttime] =useState(''); const[selecteddist,setselecteddist] =useState();
let assembleid=localStorage.getItem("assemblyid");
  let ulbcode = localStorage.getItem("ulbid"); let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid"); let deptId = localStorage.getItem("deptid");
  const formik = useFormik({
    initialValues: {
      department_id:"",ulb_id:"",
      district_id: "",
      mandal_id:"",
      type: roleid === "119"  || roleid === "113"? "32" : (roleid === "117" || roleid === "111") ? "31": "",
    },

  })

const officertypeOptions = [
  ...(["114", "115", "116"].includes(roleid)
    ? [{ value: "60", label: "HOD Officers" }]
    : []),
  // { value: "32", label: "District Officers" },
  ...(!["112"].includes(roleid)
    ? [{ value: "32", label: "District Officers" }]:[]),
  { value: "31", label: "Mandal Officers" },
];

  useEffect(() => {
   datetime(setcurrentdate,setcurrenttime);
  }, []);

  function fetchOfficerDetails(payload) {
   
    store.dispatch({ type: "SHOW_SPINNER" });
  
      KpiService.getDeptWiseMappedOfficersDetails(payload)
        .then((res) => {
  
          if (res?.data?.SCODE === "01") {
            const empData = Array.isArray(res.data.dataList) ? res.data.dataList : [];
            setEmpdata(empData);
          } 
          else {
            if (res?.data?.SCODE === "03"){
  
            }
            const message = res?.data?.SDESC || "Unexpected response format.";
            showAlertMessage(message, "warning",()=>{ setEmpdata([])});
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          showAlertMessage("Error fetching data. Please try again.", "warning");
        })
        .finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
          })
    }

const getOfficersData=(dept,mandal_id,ofcid,dist)=>{
  setlogindeptid(dept);
 let department=["111","113","114"].includes(roleid)? deptId:dept;
 
if(["111","117","113","119"].includes(roleid)){
      setselecteddist(localStorage.getItem("districtname"))
    }
    else{
   const filterdistrict = distlist?.filter(item=>item.id === dist);
    setselecteddist(filterdistrict[0]?.value);
    }
  setEmpdata([]);
  if (!dept || !ofcid) {return;}

 if(ofcid === "31")
 {
  if(!mandal_id || mandal_id === null|| mandal_id === "null"){return;}
 }
  const payload = {
    userId: username,
    deptId: dept,
    officerID: ofcid,
    ...(roleid !== "112" ? { distId: ofcid === "60" ? "0" : dist } : {}),
    ...(ofcid === "32" || ofcid === "60"
      ? { mandalId: "0", ulbId: "0" }
      : {
          mandalId: ulbdeptlist.includes(department) ? "0" : mandal_id,
          ulbId: ulbdeptlist.includes(department)
            ? roleid === "117"
              ? "0"
              : mandal_id
            : "0",
        }),

        ...(roleid === "112" ? {constId:assembleid}:{})
  };
    fetchOfficerDetails(payload);
}
  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });

   
    let params={
      userId:username
    }
    MasterService.getDeptartments(params).then((res) => {
      if (res.data.SDESC) {
       
        setDeptlist([ { dept_id: "0", dept_name: "All",deptcode:"" }, ...(res.data.SDESC ?? []) ]);
      }
    });
    if(roleid === "114" ||  roleid === "113" || roleid === "111" ){
      formik.setFieldValue("department_id",deptId);
      setDeptEnb(true);
    }
    else{
      formik.setFieldValue("department_id","");
    }
    MasterService.getDistricts(params).then((res) => {
      if (res.data) {
      setDists(res.data);
          setDistrictList([ { id: "0", value: "All"}, ...(res.data ?? []) ]); 
      }
    });
 if(["113","119","111","117"].includes(roleid)){
       formik.setFieldValue("type","");
      formik.setFieldValue("district_id",district);
  MandalData(district,deptId);
   setselecteddist(localStorage.getItem("districtname"))
    if(["111","117"].includes(roleid)){formik.setFieldValue("type","31");ulbdeptlist.includes(deptId)?formik.setFieldValue("ulb_id", ulbcode) :formik.setFieldValue("mandal_id", mandal) ;
    }
    }

    if(["111"].includes(roleid)){
      getOfficersData(deptId,ulbdeptlist.includes(deptId)? ulbcode:mandal,"31",district)
    }
 
    if(roleid !== "116"){
      setlogindeptid(deptId);
    }
   
 if(roleid === "112"){
  formik.setFieldValue("type","31");
   formik.setFieldValue("district_id",district);};
    store.dispatch({ type: "HIDE_SPINNER" });
  },[]);


  const MandalData=(val,dept)=>{
    setEmpdata([]);
    formik.setFieldValue("mandal_id","");
    formik.setFieldValue("ulb_id","");

    if(!val){return;}
    if(ulbdeptlist.includes(dept)){
  let params1 = { userId: username ,districtId: val };
             KpiService.getulbList(params1).then((response) => {
              if (response.data ) {
               
               
                if(response.data.SCODE === "01"){
                setulblist([ { ulb_code: "0", ulb_name: "All"}, ...(response.data.SDESC ?? []) ]);}
                else{
                setulblist([]);

                }
              }
            });
    }
    else{
 let params = { "district_id": val }
        MasterService.getMandals(params).then((res) => {
          if (res.data) {           
              setMandalList([ { id: "0", value: "All"}, ...(res.data ?? []) ]);
            }
        });
    }     
  }


   const constMandalData=(dist,const_id,dept)=>{
    setlogindeptid(dept);
    setulblist([]);setMandalList([]);
    setEmpdata([]);
    formik.setFieldValue("mandal_id","");
    if(!dept){return;}
    if(ulbdeptlist.includes(dept)){
  let params1 = { userId: username ,constId:const_id,distId:dist };
             KpiService.getConstWiseUlbs(params1).then((response) => { if (response.data ) { if(response.data.SCODE === "01"){ setulblist([ { ulb_code: "0", ulb_name: "All"}, ...(response.data.SDESC ?? []) ]);} else{ setulblist([ { ulb_code: "0", ulb_name: "All"} ]); } } });
    }
    else{
 let params = {  userId: username,constId:const_id,distId:dist }
        KpiService.getConstWiseMandals(params).then((res) => { if (res.data.SCODE === "01") { setMandalList([ { id: "0", value: "All"}, ...(res.data.SDESC ?? []) ]); } });
    }     
  }
      const filteredDataa =
      searchText1.length > 0 && Empdata?.length
        ? Empdata.filter((item) => {
            return (
              item &&
              Object.keys(item).some((key) => {
                const value = item[key];
                return ( value !== null &&value.toString().toLowerCase().includes(searchText1.toLowerCase()) );
              })
            );
          })
        : Empdata;

 React.useEffect(() => {
    if ((roleid === "111") || (roleid === "117")) {
      setDistEnb(true)
      setmandalenb(true)
    }
    if (roleid === "116") {
      setDistEnb(false)
    }
    if (roleid === "113" || roleid === "119") {
      setDistEnb(true)
    }
    if(roleid === "112"){setDistEnb(true)}
  }, [])
  const hodenb=(val)=>{
    if(val){ 
      setlogindeptid(val);
      if(formik.values.district_id )
        { MandalData(formik.values.district_id,val) }
        if(ulbdeptlist.includes(val) && roleid==="117"){
      formik.setFieldValue("ulb_id","0");
       getOfficersData(val,"0",formik.values.type,formik.values.district_id); 
    }
    else{
      if(roleid === "117"){
        formik.setFieldValue("mandal_id",mandal);
          getOfficersData(val,mandal,formik.values.type,formik.values.district_id); 
        }
          else{
            if(!ulbdeptlist.includes(val) && (roleid=== "119")){
          getOfficersData(val,formik.values.mandal_id,formik.values.type,formik.values.district_id);
        }
          else{
           getOfficersData(val,ulbdeptlist.includes(val)? formik.values.ulb_id:formik.values.mandal_id,formik.values.type,formik.values.district_id);
         }
          }
        }
  }
}

const getData=(dept,mandal_id,ofcid,distid,logindeptid)=>{
  if(ofcid==="31"){
    MandalData(distid,logindeptid);
  }else {
     getOfficersData(dept,mandal_id,ofcid,distid);
  }
}

const ofcTypeFun = (value) => {
  const deptId = formik.values.department_id;
  if (value === "60" || (["119", "113"].includes(roleid) && value === "32")) {
    getOfficersData(deptId, "0", value, value === "60" ? "0" : district);
  }
  if (!["119", "113","112"].includes(roleid)) {
    formik.setFieldValue("district_id", "");
    setMandalList([]);
    setulblist([]);
  }
  formik.setFieldValue("mandal_id", "");
  formik.setFieldValue("ulb_id", "");
};


  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  > <div className='sa-title'> <h2>Mapped <span> Employees</span></h2> </div> </Container>

      <DESUI.Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

            <div className='mandal-container p-4 mt-2'>

              <Row>
  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold"> HOD Name </label> <span style={{ color: "red" }}> *</span> 
  <Select
                                    {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: deptnb, extraOnChange: (option) => {
                                      if(roleid === "112"){
                                        getOfficersData(option ? option.dept_id : "","0","31",district);
                                        // constMandalData(district,assembleid,option? option.dept_id:"")
                                      }
                                      else{ hodenb(option ? option.dept_id : "");}
                                     } })}
                                  />
    </Col>
               
               {roleid !== "112" && (
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> Officer Type </label> <span style={{ color: "red" }}> *</span>
                                            <Select {...commonSelectProps({ name: "type", options: officertypeOptions, value: formik.values.type, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: roleid === "117" || roleid === "111", extraOnChange: (option) => { ofcTypeFun(option? option.value:"") } })} />   
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="type" /> </span>
                </Col>)}

                {((formik.values.type==="31"||formik.values.type==="32") && roleid !== "112") &&
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span> <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: distEnb, extraOnChange: (option) => {getData(formik.values.department_id,ulbdeptlist.includes(logindeptid)?formik.values.ulb_id:formik.values.mandal_id,formik.values.type,option? option.id:"",logindeptid); } })} />                      
                </Col>}
               
               {roleid === "112" &&
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> Constituency </label> <span style={{ color: "red" }}> *</span>
                                           <Field type="text" className="form-control" value={localStorage.getItem("assemblyname")} disabled/>
                </Col>
}
                {(formik.values.type === "31" && roleid !== "112") &&
             
                 <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                    {ulbdeptlist.includes(logindeptid)? <>
                  <label className="mb-1 fw-bold"> ULB </label> <span style={{ color: "red" }}> *</span>
                                                      <Select {...commonSelectProps({ name: "ulb_id", options: ulblist, value: formik.values.ulb_id, optionValueKey: "ulb_code", optionLabelKey: "ulb_name", formik, isDisabled: mandalenb, extraOnChange: (option) => {getOfficersData(formik.values.department_id,option? option.ulb_code:"",formik.values.type,formik.values.district_id); } })} />                      

                 
</>:
<>
                  <label className="mb-1 fw-bold"> Mandal </label> <span style={{ color: "red" }}> *</span>
                                                      <Select {...commonSelectProps({ name: "mandal_id", options: MandalList, value: formik.values.mandal_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: mandalenb, extraOnChange: (option) => {getOfficersData(formik.values.department_id,option? option.id:"",formik.values.type,formik.values.district_id); } })} />                      

                 </>}

                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="mandal_id" /> </span>
                </Col>}

               
        
              </Row>
            </div>


          </Form>
        </FormikProvider><br />
       

        <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} > <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText1} onChange={(event) => setSearch1(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} /> </div> </Col>
<Col className=" mb-2 " > <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "Department Wise Officers details",["111","117","119","113","112"].includes(roleid) ? 8 : formik.values.type === "31" ? 10: 9)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button> <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Department Wise Officers details")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button> </Col>
            </Row>
              <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 " >

<span className="fw-semibold"> Mapped Employees Details { Empdata?.length > 0 && ( formik.values.department_id === "0" ? ` of All Departments ${formik.values.type !== "60" ? `${selecteddist} District` : "" } ` : (Empdata[0]?.deptcode && Empdata[0]?.dept_name ? ` of ${Empdata[0].deptcode}-${Empdata[0].dept_name} ${formik.values.type !== "60" ?  `${selecteddist} District` : "" } District` : "") ) } </span>
                  <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>        
               
                

                  </div>
            <div id="table-scroll"className="table-scroll">
              <div className="table-wrap">
            <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered" >
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}> 

                  <tr className="text-center"> <th  > Sl No. </th>{formik.values.district_id==="0"&&<th  className="indicator-column">District</th>}{formik.values.department_id==="0"&&<th  className="indicator-column">HOD Name</th>}<th  >Cfms Id/User Id </th>  {formik.values.type === "31" &&<th  > {ulbdeptlist.includes(logindeptid)? "ULB":"Mandal"}  </th>} <th  > Position Id/Name  </th> <th  >Employee Name   </th>
                   {/* <th  > Date of Birth  </th> */}
                    <th  > Mobile  </th> <th  > Email  </th> 
                    {/* <th  > Gender  </th>  */}
                    <th  > Working Office  </th> </tr> </thead>
                <tbody>
                  {filteredDataa?.length === 0 || filteredDataa?.length === undefined ? (
                    <tr> <td className="text-center" colSpan={ ["111","117","119","113","112"].includes(roleid) ? 8 : formik.values.type === "31" ? 10: 9}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                  ) : (
                    (() => {

                      return filteredDataa?.map((detail, i) => {


                        return (
                          <tr key={i}> 
                          <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "center" }}>{i + 1}</td>
                          {formik.values.district_id==="0"&&<td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit"}} className="indicator-column">{detail.district_name}</td> }
                           {formik.values.department_id==="0"&&<td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit"}} className="indicator-column">{detail.deptcode}<br/>{detail.dept_name}</td>} <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}> {detail.user_data}</td> {formik.values.type === "31" &&  <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>
                            {roleid !== "112" ? (ulbdeptlist.includes(logindeptid) ? detail.ulb_name : detail.mandal_name) : detail.mandal_name}
                            </td>} <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.position_id}{detail.position_name ? `/${detail.position_name}`:""}</td> <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.emp_name}</td>
                            {/* <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.date_of_birth}</td>  */}
                           <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.mobile_number}</td> <td></td> 
                           {/* <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.gender}</td> */}
                            <td style={{ color: detail.user_id === "Officer Not Mapped" ? "red" : "inherit", textAlign: "left" }}>{detail.working_office}</td> </tr>
                        );
                      });
                    })()
                  )}
                </tbody>

              </table>

</div>
            </div>

           
<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </DESUI.Container >
    </>
  );
};